import { Tabs } from "antd";
import Content from "layouts/agencyPortal/dashboard/content";
import PageLayout from "layouts/agencyPortal/dashboard/pageLayout";
import CommunicationTaskListTab from "pages/communications/communicationTaskListTab";
import { Navigate, useLocation, useNavigate } from "react-router-dom";

const items = [
  {
    key: "dashboard",
    label: "Dashboard",
    // This is a placeholder for the dashboard tab content, which will be implemented in a future iteration
    children: <CommunicationTaskListTab communicationMediums={null} />,
  },
  {
    key: "ai-calls",
    label: "AI Call",
    children: (
      <CommunicationTaskListTab communicationMediums={["artificial_intelligence_phone_agent"]} />
    ),
  },
  {
    key: "emails",
    label: "Email",
    children: <CommunicationTaskListTab communicationMediums={["email"]} />,
  },
  {
    key: "letters",
    label: "Letter",
    children: (
      <CommunicationTaskListTab
        communicationMediums={["in_house_letter", "first_party_letter", "third_party_letter"]}
      />
    ),
  },
  {
    key: "texts",
    label: "Text",
    children: <CommunicationTaskListTab communicationMediums={["text"]} />,
  },
  {
    key: "voicemails",
    label: "Voicemail",
    children: <CommunicationTaskListTab communicationMediums={["voicemail"]} />,
  },
];

function CommunicationTaskPage() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const activeKey = pathname.split("/").pop() || "dashboard";

  // If the URL doesn't match any of the tab keys, redirect to the dashboard
  if (!items.some((item) => item.key === activeKey)) {
    return <Navigate to="/communications/dashboard" />;
  }

  const handleTabChange = (key) => {
    navigate(`/communications/${key}`);
  };

  return (
    <PageLayout>
      <Content>
        <Tabs activeKey={activeKey} items={items} onChange={handleTabChange} />
      </Content>
    </PageLayout>
  );
}

export default CommunicationTaskPage;
